import { useRouter } from "@tanstack/react-router";
import type { ReactNode } from "react";

interface Props {
  title: string;
  /** Show a back button on the left. Default: route history pop. */
  back?: boolean | (() => void);
  /** Optional right-side action button content. */
  right?: ReactNode;
  /** Hide the bottom border (used by Hero pages that paint own background). */
  borderless?: boolean;
}

/**
 * Telegram WebView header. 1:1 with design `.tg-header` — fixed 44px height,
 * sticky top, system font. Back button uses TanStack Router history; right
 * action slot accepts arbitrary node so callers can render bell/filter/+
 * buttons matching each page's design.
 */
export function TgHeader({ title, back, right, borderless }: Props) {
  const router = useRouter();
  const onBack = () => {
    if (typeof back === "function") {
      back();
      return;
    }
    if (router.history.length > 1) {
      router.history.back();
    } else {
      router.navigate({ to: "/" as never });
    }
  };

  return (
    <div className="tg-header" style={borderless ? { borderBottom: 0 } : undefined}>
      {back ? (
        <button type="button" className="tg-header__back" aria-label="Back" onClick={onBack}>
          ←
        </button>
      ) : (
        <button
          type="button"
          className="tg-header__back"
          style={{ visibility: "hidden" }}
          tabIndex={-1}
          aria-hidden
        >
          ←
        </button>
      )}
      <div className="tg-header__t">{title}</div>
      <div className="tg-header__r">{right ?? <span style={{ width: 24 }} />}</div>
    </div>
  );
}
